import React from "react";
import __ from "src/utils/Translations";
import TransHtml from "src/Components/TransHtml";

export const getLocalizationsImportInstructions = (): React.ReactNode[] => [
  <TransHtml text="Pierwszy wiersz pełni funkcję nagłówka, a <b>import danych rozpoczyna się od drugiego wiersza.</b> Zawartość pierwszego wiersza nie jest przetwarzana." />,
  <TransHtml text="Każdy wiersz w pliku powinien zawierać maksymalnie 3 kolumny. <b>Wypełniasz tylko te pola, które chcesz uzupełnić</b> - pozostałe możesz zostawić puste." />,
  <TransHtml text="<b>Import służy wyłącznie do dodawania nowych lokalizacji</b> - nie można przez niego edytować istniejących wpisów. <b>Edycja odbywa się ręcznie przez panel administracyjny.</b>" />,
  <TransHtml text="Lokalizacje, których nazwa pokrywa się z już istniejącą pozycją w słowniku (z pominięciem wielkości liter i zbędnych spacji), zostaną pominięte z informacją." />,
  <TransHtml text="<b>Możesz skorzystać z gotowego szablonu</b> z nazwami kolumn lub wyeksportować aktualną listę lokalizacji." />,
  <TransHtml text="Oczekiwany format plików to <b>CSV UTF-8 rozdzielany średnikami lub XLSX</b>" />,
];

export const getLocalizationsUpdateFields = (): string[] => [
  __("Miasto"),
  __("Kod pocztowy"),
  __("Ulica i numer"),
];
